<template>
<svg viewBox="0 0 48 48" :fill="useCurrentColor ? 'currentColor' : 'currentColor'" :class="[`${prefix}-icon`, `${prefix}-icon-heater`]" width="1em" height="1em" v-bind="$attrs"><path fill-rule="evenodd" clip-rule="evenodd" d="M20 5a2 2 0 012 2v15h4V7a2 2 0 012-2h10a2 2 0 012 2v15h4a1 1 0 011 1v2a1 1 0 01-1 1h-4v15a2 2 0 01-2 2H28a2 2 0 01-2-2V26h-4v15a2 2 0 01-2 2H10a2 2 0 01-2-2V26H4a1 1 0 01-1-1v-2a1 1 0 011-1h4V7a2 2 0 012-2h10zm-2 4h-6v30h6V9zm12 0h6v30h-6V9z"/></svg>
</template>
<script>

export default {
  name: 'IconHeater',
  props: {
    prefix: {
        type: String,
        default: 'm',
    },
    useCurrentColor: {
        type: Boolean,
        default: false,
    },
  },
};
</script>
